import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import Instagram from '@mui/icons-material/Instagram';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL, getCategoryList } from '../../networkCalls';

const promise = getCategoryList();
const FotterMain = () => {
    const [catlist, setCatlist] = React.useState();
    useEffect(() => {
        promise.then(data => {
            setCatlist(data?.CategoryListArray);
        });
    }, [catlist]);

    return (
        <>
            <div className='bgdgray site-footer'>
                <div className="decor decor--type--bottom site-footer__decor">
                    <div className="decor__body">
                        <div className="decor__start"></div>
                        <div className="decor__end"></div>
                        <div className="decor__center"></div>
                    </div>
                </div>
                <div className='container'>
                    <div className='row pt-5 pb-4'>
                        <div className='col-lg-4 col-md-6 col-12 mb-2'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h3 className='text-white f18  mb-3'>Contact Us</h3>
                                    <p className='mb-0 f16'>HONDA INDIA POWER PRODUCTS LTD.</p>
                                    <p className='f12'>(Formerly Honda Siel Power Products Ltd.)</p>
                                </div>
                            </div>
                            <div className='row f13'>
                                <div className='col-7'>
                                    <p className='text-white  mb-1'>HEAD OFFICE</p>
                                    <p>
                                        Plot no 5 Sector 41 Kasna,<br />
                                        Greater Noida Industrial Area<br />
                                        Distt Gautam Budh Nagar (UP)<br />
                                        Pin code: 201310
                                    </p>
                                    <p><span className='text-white'>Telephone:</span> 0120-2590100</p>
                                    <p>
                                        <span className='text-white'>Toll Free:</span> 1800-11-2323<br />
                                        <span className='text-white'>E-Mail (Support):</span> <a className='footerlinktext' href="mailto:customer.support@hipp.co.in">customer.support@hipp.co.in </a><br />
                                        <span className='text-white'>E-Mail (Sales):</span> <a className='footerlinktext' href="mailto:ho.mktg@hipp.co.in">ho.mktg@hipp.co.in</a><br />
                                        <span className='text-white'>E-Mail (Service):</span> <a className='footerlinktext' href="mailto:ho.service@hipp.co.in">ho.service@hipp.co.in</a>
                                    </p>
                                </div>
                                <div className='col-5'>
                                    <p className='text-white mb-1'>REGISTERED OFFICE</p>
                                    <p>409, DLF Tower B<br />Jasola Commercial<br />Complex, South Delhi<br />New Delhi- 110025</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-12 mb-2'>
                            <div className='row'>
                                <div className='col-6'>
                                    <h3 className='text-white f18 mb-3'>Company</h3>
                                    <ul className='flinkmanu'>
                                        <li><Link to="/about-us">About Us</Link></li>
                                        <li><Link to="/board-of-directors">Board of Directors</Link></li>
                                        <li><Link to="/why-buy-a-honda">Why Buy A Honda</Link></li>
                                        <li><a href="https://careers.hondaasiaoceania.com/go/HIPP-Jobs/665444/" target='_blank'>Careers</a></li>
                                        <li><Link to="/exports">Exports</Link></li>
                                        <li><Link to="/events">Newsroom</Link></li>
                                        {/* <li><Link to="/press-release">Press Release</Link></li> */}
                                        <li><a href='https://www.hondaindiafoundation.org/' target='_blank'>CSR</a></li>
                                        <li><Link to="/online-payment">Online Payment</Link></li>
                                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                        <li><Link to="/return-refund-policy">Return & Refund Policy</Link></li>
                                        <li><Link to="/terms-of-use">Terms and Conditions</Link></li>
                                        <li><Link to="/faqs">FAQs</Link></li>
                                        <li><Link to="/contact-us">Contact Us</Link></li>
                                        <li><Link to="/blog">Blog</Link></li>
                                        <li><a href="https://smartodr.in/" target='_blank'>ODR Portal</a></li>
                                        <li><Link to="/e-waste-management">E-waste Management</Link></li>
                                    </ul>
                                </div>
                                <div className='col-6'>
                                    <h3 className='text-white f18  mb-3'>Products</h3>
                                    <ul className='flinkmanu'>
                                        {catlist && catlist?.length > 0 && catlist?.map((data, i) => (
                                            <li key={i}><a href={`/product-category/${data?.slug}`} >{data?.name}</a></li>))}


                                        <li><a href='https://global.honda/en/?utm_source=hipp&utm_medium=web&utm_campaign=footer' target='_blank'>Global Honda</a></li>
                                        <li><a href='https://global.honda/en/brand/?utm_source=hipp&utm_medium=web&utm_campaign=footer' target='_blank'>Global Brand Slogan</a></li>
                                        <li><a href='https://global.honda/en/about/history.html?utm_source=hipp&utm_medium=web&utm_campaign=footer' target='_blank'>Honda History</a></li>
                                        <li><a href='https://global.honda/en/about/philosophy/?utm_source=hipp&utm_medium=web&utm_campaign=footer' target='_blank'>Honda Philosophy</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-12 mb-2'>
                            <div className='row'>
                                <div className='col-12'>
                                    <h3 className='text-white f18  mb-3'>Environmental Initiatives</h3>
                                    <div className='d-flex align-items-center'>
                                        <div className='p-2'>
                                            <LazyLoadImage
                                                alt=""
                                                effect="blur"
                                                className='img-fluid mb-3'
                                                src={`${baseURL}images/1.png`}
                                            />
                                        </div>
                                        <div className='p-2'>
                                            <LazyLoadImage
                                                alt=""
                                                effect="blur"
                                                className='img-fluid mb-3'
                                                src={`${baseURL}images/2.png`}
                                            />
                                        </div>
                                        <div className='p-2'>
                                            <a href="https://sustainability.honda.asia/environment" alt="" target="_blank">
                                                <LazyLoadImage
                                                    alt=""
                                                    effect="blur"
                                                    className='img-fluid mb-3 '
                                                    src={`${baseURL}images/3.png`}
                                                />
                                            </a>
                                        </div>
                                    </div>
                                    {/* <div><LazyLoadImage
                                        alt=""
                                        effect="blur"
                                        className='img-fluid mb-3'
                                        src={`${baseURL}images/icon-f.png`} 
                                    /></div> */}
                                </div>
                            </div>
                            <div className='row f13'>
                                <div className='col-7'>
                                    <p className='text-white  mb-1'>Follow us on social networks</p>
                                    <div>
                                        <a href="https://www.facebook.com/hondaindiapowerproductslimited/" target="_blank" className='text-white'><FacebookIcon /></a>
                                        <a href="https://www.youtube.com/channel/UCw5zgVa0o9sqcwZxI8axfHw/" target="_blank" className='text-white ms-2'><YouTubeIcon /></a>
                                        <a href="https://www.linkedin.com/company/honda-india-power-products-ltd/" target="_blank" className='text-white ms-2'><LinkedInIcon /></a>
                                        <a href="https://www.instagram.com/hondaindiapowerproducts/" target="_blank" className='text-white ms-2'><Instagram /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='bgred text-white copyright_wrap'  >
                <div className='container'>
                    <div className='row'>
                        <div className='col-12 text-center f12 pt-2 pb-2'>
                            Copyright @ Honda India Power Products Ltd. (Formerly Honda Siel Power Products Ltd.), 2025, All Rights Reserved.
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
export default React.memo(FotterMain)